







































import { Component, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { navigatorLang } from '@/plugins/i18n';
import { Document } from '@/plugins/podolib/services/doctor';

import type { Consent } from '@/plugins/podolib/services/doctor';
import { Severity } from '@sentry/types';

interface IAccountConsent extends MixinDialog {
  _open(consent: Consent): void;
}

@Component<IAccountConsent>({
  mounted() {
    this.$pdc.bus!.on('account:consent:open', this._open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('account:consent:open', this._open);
  },
})
export default class AccountConsent extends MixinDialog {
  consent: Consent = null!;

  pending = false;
  error = null;
  success = false;

  get lang() {
    return this.$pdc.doctor!.current?.config.lang || navigatorLang();
  }

  get documentLink() {
    return (
      this.consent?.links?.find((link) => link.lang === this.lang) ??
      this.consent?.links?.find((link) => link.lang === 'en')
    )?.link;
  }

  get selectedDocumentTitle() {
    switch (this.consent?.document) {
      case Document.TOU:
        return this.$t('commons.sentences.account.terms-and-conditions.doc-tou.title');
      case Document.DPA:
        return this.$t('commons.sentences.account.terms-and-conditions.doc-dpa.title');
      default:
        return this.$t('commons.sentences.terms-conditions');
    }
  }

  _open(consent: Consent) {
    this.consent = consent;

    this.open();
  }

  async save() {
    // Avoid duplication of the process
    if (this.pending) return;

    try {
      // Reset flags
      this.success = false;
      this.error = null;
      // Set 'pending' flag
      this.pending = true;

      // Try to patch the doctor ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data: {
          consents: this.$pdc.doctor!.current.consents?.map((consent) => {
            if (consent.document === this.consent.document && consent.version === this.consent.version) {
              return {
                ...consent,
                consented: true,
                ip: window.ip,
                date: new Date(),
              };
            }
            return consent;
          }),
        },
      });

      this.success = true;
    } catch (e) {
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
    }
  }

  @Watch('success')
  onSuccess(state: boolean) {
    if (state) {
      this.close();
      this.$nextTick(() => {
        setTimeout(() => {
          // Reset flags
          this.success = false;
          this.error = null;

          this.$pdc.bus!.emit('account:consent:closed');
        }, 200);
      });
    }
  }
}
